import React from 'react'
import PropTypes from 'prop-types'

const CopyModalTab = ({ 
    Name,
    CopyProduct
 }) => {
    return (
        <li className="list-option" onClick={() => CopyProduct(Name)}>
            <h4 className="headline headline-sm">{Name}</h4>
        </li>
    );
};

CopyModalTab.propType = {
    Name: PropTypes.string.isRequired,
    CopyProduct: PropTypes.func
};

export default CopyModalTab;